import { useEffect, useMemo, useRef, useState } from 'react';
import { fetchArticles } from '../api/community';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import SmartImg from "../components/SmartImg";

const CATS = [
  { key: 'EVENT', label: 'Events' },
  { key: 'DJ', label: 'DJs' },
  { key: 'AFFILIATE', label: 'Affiliates' },
];

const KALUKI_POSTER = '/assets/community/8273b509-c413-4b18-89fc-059814fb796c.png';
const DO_NOT_SLEEP_JUNE_POSTER = '/assets/30fb2c7a-8abc-4a3c-b91a-8ebe388ee80e.png';
const DO_NOT_SLEEP_POSTER = '/assets/community/b0b39892-27f9-4476-af50-f4d20d64e09b.png';
const CHRIS_STUSSY_POSTER = '/assets/community/931034ec-7374-496d-9754-cc1d8d26c87e.png';
const JOY_IBIZA_POSTER = 'https://www.528ibiza.com/media/cache/ad/15/ad155a56efa311ba4b7368007ec282d0.png';
const EASTENDERZ_SEPTEMBER_POSTER = '/assets/community/zzeastenddubsdonee.png';
const EASTENDERZ_FIFTEEN_SEPTEMBER_POSTER = '/assets/community/aaaeast%20ends%20dubdtttttt.png';
const EASTENDERZ_SEVEN_JULY_POSTER = 'https://hiibiza.b-cdn.net/assets/3d7a04a5-f0e7-4a07-a003-a023e86fb133--2026_HI_EAST&DUBS_ANNOUNCE_WEBSITE_1920X1080.jpg';
const PARADISE_UNVRS_JULY_POSTER = '/assets/community/cd1c7392-cbe6-4ff4-8137-755f05638272.png';
const CARL_COX_UNVRS_POSTER = '/assets/community/photo_2026-07-12_12-41-12.jpg';
const JAMIE_JONES_PARADISE_POSTER = '/assets/community/photo_2026-06-24_16-06-28.jpg';
const EASTENDERZ_SIXTEEN_JUNE_POSTER = '/assets/community/4ec66bc1-d1dc-4a01-ae9f-45dc413d57ba.png';
const EASTENDERZ_POSTER = '/assets/community/3eb0663c-da5c-4172-af5e-1b260291d72d.png';
const JOSH_BAKER_POSTER = '/assets/gdb/zzz11111111111.png';

const KALUKI_GUIDE = {
  category: 'EVENT',
  title: 'Kaluki 528 Ibiza 2026: Sunday Open-Air Tech House Party',
  excerpt: 'Julian Fijma, Kepler B2B Burnski, Robbie Doherty, Tommy Phillips and Pirate Copy bring Kaluki to 528 Ibiza on Sunday 31 May.',
  to: '/community/kaluki-528-ibiza-31-may-2026',
  thumbnailUrl: KALUKI_POSTER,
  thumbnailAlt: 'Kaluki at 528 Ibiza event poster',
};

const DO_NOT_SLEEP_JUNE_GUIDE = {
  category: 'EVENT',
  title: 'Do Not Sleep at Amnesia Ibiza: 4 June 2026 Guide',
  excerpt: 'Sidney Charles B2B L.P. Rhythm, Ozzie Guven, jWave B2B Boss Priester and Lissy Lubeck bring Do Not Sleep back to Amnesia Ibiza.',
  to: '/community/do-not-sleep-amnesia-ibiza-4-june-2026',
  thumbnailUrl: DO_NOT_SLEEP_JUNE_POSTER,
  thumbnailAlt: 'Do Not Sleep at Amnesia Ibiza 4 June event poster',
};

const DO_NOT_SLEEP_GUIDE = {
  category: 'EVENT',
  title: 'Do Not Sleep at Amnesia Ibiza 2026',
  excerpt: 'Richy Ahmed, Gaskin, M-High B2B Job de Jong, Ellia Jaya and Watchers take Amnesia into a late-night house and tech house session.',
  to: '/community/do-not-sleep-amnesia-ibiza-28-may-2026',
  thumbnailUrl: DO_NOT_SLEEP_POSTER,
  thumbnailAlt: 'Do Not Sleep at Amnesia Ibiza event poster',
};

const CHRIS_STUSSY_GUIDE = {
  category: 'EVENT',
  title: 'Chris Stussy USS at Pacha Ibiza 2026',
  excerpt: 'A music-first Pacha Ibiza night built around deep house, minimal groove and one of the strongest modern underground followings in house music.',
  to: '/community/chris-stussy-uss-pacha-ibiza-2026',
  thumbnailUrl: CHRIS_STUSSY_POSTER,
  thumbnailAlt: 'Chris Stussy presents USS at Pacha Ibiza event poster',
};

const EASTENDERZ_SEPTEMBER_GUIDE = {
  category: 'EVENT',
  title: 'East End Dubs at Hï Ibiza: 1 September 2026 Guide',
  excerpt: 'East End Dubs, Miguelle & Tons, Job De Jong and Delilah lead The Theatre while Paco Osuna, Joëlla Jackson and Easttown bring Club Room / Now Here.',
  to: '/community/eastenderz-hi-ibiza-1-september-2026',
  thumbnailUrl: EASTENDERZ_SEPTEMBER_POSTER,
  thumbnailAlt: 'East End Dubs presents Eastenderz at Hï Ibiza 1 September 2026 event artwork',
};

const EASTENDERZ_FIFTEEN_SEPTEMBER_GUIDE = {
  category: 'EVENT',
  title: 'Eastenderz at Hï Ibiza: 15 September 2026 Guide',
  excerpt: 'East End Dubs, Marco Carola, Gaskin and Lola Palmer lead The Theatre while Paco Osuna, Luuk van Dijk and Chinonegro bring Club Room / Now Here.',
  to: '/community/eastenderz-hi-ibiza-15-september-2026',
  thumbnailUrl: EASTENDERZ_FIFTEEN_SEPTEMBER_POSTER,
  thumbnailAlt: 'East End Dubs presents Eastenderz at Hï Ibiza 15 September 2026 event artwork',
};

const PARADISE_UNVRS_JULY_GUIDE = {
  category: 'EVENT',
  title: 'Paradise at [UNVRS] Ibiza: 22 July 2026 Guide',
  excerpt: 'Jamie Jones B2B Franky Rizardo lead Paradise tonight with Sosa, ALISHA and Julian Fijma, while Job de Jong, Dimmish, Pirate Copy and Vanee take Wild Comet.',
  to: '/community/jamie-jones-paradise-unvrs-ibiza-22-july-2026',
  thumbnailUrl: PARADISE_UNVRS_JULY_POSTER,
  thumbnailAlt: 'Paradise at [UNVRS] Ibiza 22 July 2026 event artwork',
};

const CARL_COX_UNVRS_GUIDE = {
  category: 'EVENT',
  title: 'Carl Cox at [UNVRS] Ibiza: 12 July 2026 Guide',
  excerpt: 'Carl Cox leads [UNVRS] tonight with Chris Stussy and Karretero, while Melon Bomb brings the Wild Comet room into play.',
  to: '/community/carl-cox-unvrs-ibiza-12-july-2026',
  thumbnailUrl: CARL_COX_UNVRS_POSTER,
  thumbnailAlt: 'Carl Cox at [UNVRS] Ibiza 12 July 2026 event artwork',
};

const EASTENDERZ_SEVEN_JULY_GUIDE = {
  category: 'EVENT',
  title: 'Eastenderz at Hï Ibiza: 7 July 2026 Guide',
  excerpt: 'East End Dubs, Franky Rizardo, Gaskin and Ellia Jaya take The Theatre while Paco Osuna, Rendher and Wheats lead Club Room / Now Here.',
  to: '/community/eastenderz-hi-ibiza-7-july-2026',
  thumbnailUrl: EASTENDERZ_SEVEN_JULY_POSTER,
  thumbnailAlt: 'Eastenderz at Hï Ibiza 7 July 2026 event artwork',
};

const JOY_IBIZA_GUIDE = {
  category: 'EVENT',
  title: 'JOY Ibiza at 528 Ibiza: 5 July 2026 Guide',
  excerpt: 'Boss Priester, Dennis Quin, Jesse Maas, Michel De Hey, Ozzie Guven, Paisley Jensen and Robbie Doherty bring JOY to 528 Ibiza today.',
  to: '/community/joy-ibiza-528-5-july-2026',
  thumbnailUrl: JOY_IBIZA_POSTER,
  thumbnailAlt: 'JOY Ibiza at 528 Ibiza 5 July 2026 event poster',
};

const JAMIE_JONES_PARADISE_GUIDE = {
  category: 'EVENT',
  title: 'Jamie Jones Paradise at UNVRS Ibiza: 24 June 2026 Guide',
  excerpt: 'Jamie Jones B2B The Martinez Brothers lead Paradise at UNVRS tonight with Cloonee, Richy Ahmed, Joella Jackson and Wild Comet guests.',
  to: '/community/jamie-jones-paradise-unvrs-ibiza-24-june-2026',
  thumbnailUrl: JAMIE_JONES_PARADISE_POSTER,
  thumbnailAlt: 'Jamie Jones Presents Paradise at UNVRS Ibiza 24 June 2026 event poster',
};

const EASTENDERZ_SIXTEEN_JUNE_GUIDE = {
  category: 'EVENT',
  title: 'Eastenderz at Hï Ibiza: 16 June 2026 Guide',
  excerpt: 'East End Dubs B2B Sosa lead The Theatre with Marsolo and DXNBY, while Paco Osuna, DJ Oliver and Manu Gonzalez take Club Room / NOW HERE.',
  to: '/community/eastenderz-hi-ibiza-16-june-2026',
  thumbnailUrl: EASTENDERZ_SIXTEEN_JUNE_POSTER,
  thumbnailAlt: 'Eastenderz at Hï Ibiza 16 June event poster',
};

const EASTENDERZ_GUIDE = {
  category: 'EVENT',
  title: 'Eastenderz Hi Ibiza 2026: East End Dubs Tuesday Residency',
  excerpt: 'Deep tech, minimal house and groove-led underground energy every Tuesday at Hi Ibiza from 2 June to 6 October 2026.',
  to: '/community/eastenderz-hi-ibiza-2026-east-end-dubs',
  thumbnailUrl: EASTENDERZ_POSTER,
  thumbnailAlt: 'Eastenderz Hi Ibiza 2026 event poster',
};

const JOSH_BAKER_GUIDE = {
  category: 'EVENT',
  title: 'Josh Baker You&Me at Amnesia Ibiza 2026',
  excerpt: 'The 2 July opening party with Josh Baker B2B Prospa, Cloonee, jWave B2B Job de Jong and Yass & Mali.',
  to: '/events/josh-baker-youme-amnesia-ibiza-2-july-2026',
  thumbnailUrl: JOSH_BAKER_POSTER,
  thumbnailAlt: 'Josh Baker and Prospa You&Me at Amnesia Ibiza event poster',
};

const FEATURED_GUIDES = [];
const GUIDE_FEED_CARDS = [EASTENDERZ_FIFTEEN_SEPTEMBER_GUIDE, EASTENDERZ_SEPTEMBER_GUIDE, PARADISE_UNVRS_JULY_GUIDE, CARL_COX_UNVRS_GUIDE, EASTENDERZ_SEVEN_JULY_GUIDE, JOY_IBIZA_GUIDE, JAMIE_JONES_PARADISE_GUIDE, EASTENDERZ_SIXTEEN_JUNE_GUIDE, DO_NOT_SLEEP_JUNE_GUIDE, KALUKI_GUIDE, JOSH_BAKER_GUIDE, DO_NOT_SLEEP_GUIDE, CHRIS_STUSSY_GUIDE, EASTENDERZ_GUIDE];

const PAGE_SIZE = 12;
const ROOT_MARGIN_PX = 600;

export default function CommunityIndex() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const q = params.get('q') || '';
  const sort = params.get('sort') || 'newest';
  const selected = (params.getAll('category')?.length ? params.getAll('category') : []);

  const [items, setItems] = useState([]);
  const [page, setPage] = useState(0);          // 0-based pages: 0,1,2,...
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showTop, setShowTop] = useState(false);

  const sentinelRef = useRef(null);
  const seenIds = useRef(new Set());
  const inflightRef = useRef(false);            // HARD LOCK to prevent double bumps

  function setParams(next) {
    const p = new URLSearchParams(search);
    Object.entries(next).forEach(([k, v]) => {
      p.delete(k);
      if (Array.isArray(v)) v.forEach(val => p.append(k, val));
      else if (v) p.set(k, v);
    });
    navigate({ search: p.toString() }, { replace: false });
  }

  const queryKey = useMemo(() => JSON.stringify({ q, sort, selected }), [q, sort, selected]);

  // Reset when filters/search/sort change
  useEffect(() => {
    setItems([]);
    setPage(0);
    setHasMore(true);
    setError('');
    seenIds.current = new Set();
    inflightRef.current = false;
  }, [queryKey]);

  // Fetch a page (one request per page, guarded by inflightRef + loading)
  useEffect(() => {
    if (!hasMore) return;
    if (loading) return;

    setLoading(true);
    setError('');

    fetchArticles({ q, category: selected, sort, page, size: PAGE_SIZE })
      .then((res) => {
        const newItems = res?.items || [];
        const total = res?.total;

        // De-dupe (protects against any backend overlap/race)
        const unique = [];
        for (const it of newItems) {
          if (!seenIds.current.has(it.id)) {
            seenIds.current.add(it.id);
            unique.push(it);
          }
        }

        setItems(prev => {
          const next = [...prev, ...unique];

          // Prefer server 'total' (your controller returns it)
          if (typeof total === 'number') {
            setHasMore(next.length < total);
          } else {
            // Fallback: if we got a full page, assume there may be more
            setHasMore(newItems.length === PAGE_SIZE);
          }

          return next;
        });
      })
      .catch((e) => {
        console.error('fetchArticles failed', e);
        setError('Could not load articles.');
        setHasMore(false);
      })
      .finally(() => {
        setLoading(false);
        inflightRef.current = false;  // release the lock so the observer can bump again
      });
  }, [page, queryKey, hasMore, loading, q, sort, selected]);

  // IntersectionObserver - unobserve -> bump page -> reobserve after fetch finishes
  useEffect(() => {
    const el = sentinelRef.current;
    if (!el) return;
    if (!hasMore) return;

    const io = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (!entry.isIntersecting) return;
        if (inflightRef.current) return; // hard lock: already queued/fetching
        if (loading) return;             // soft guard

        // Lock immediately and stop observing to avoid multiple bumps while visible
        inflightRef.current = true;
        io.unobserve(el);
        setPage(p => p + 1);
      },
      { rootMargin: `${ROOT_MARGIN_PX}px` }
    );

    io.observe(el);
    return () => io.disconnect();
  }, [hasMore, loading]); // reattach when loading flips or when we reach new state

  // Auto-fill: if page is shorter than viewport (no scroll yet), load next pages
  useEffect(() => {
    if (loading || !hasMore) return;
    const el = sentinelRef.current;
    if (!el) return;

    const vh = window.innerHeight || document.documentElement.clientHeight;
    const docH = Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight
    );

    // If content doesn't fill the viewport, bump page without waiting for a scroll
    if (docH <= vh + 1 && !inflightRef.current) {
      inflightRef.current = true;
      setPage(p => p + 1);
    }
  }, [items.length, hasMore, loading]);

  // Back-to-top visibility
  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  function MobileCategoryDropdown({ selected, onToggle }) {
    const [open, setOpen] = useState(false);
    return (
      <div className="relative">
        <button
          type="button"
          onClick={() => setOpen(o => !o)}
          className="card w-full flex items-center justify-between px-4 py-3"
          aria-haspopup="listbox"
          aria-expanded={open}
          aria-label="Select categories"
        >
          <span className="font-semibold text-white">Category</span>
          <svg
            className={`h-4 w-4 transition-transform ${open ? 'rotate-180' : ''}`}
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.17l3.71-3.94a.75.75 0 1 1 1.08 1.04l-4.24 4.5a.75.75 0 0 1-1.08 0l-4.24-4.5a.75.75 0 0 1 .02-1.06z" />
          </svg>
        </button>

        {open && (
          <div role="listbox" className="mt-2 grid gap-2" aria-label="Categories">
            {CATS.map(c => {
              const active = selected.includes(c.key);
              return (
                <button
                  key={c.key}
                  onClick={() => onToggle(c.key)}
                  className={`card py-3 text-center transition ${active ? 'border-violet-400/50' : ''} hover:border-white/20`}
                  role="option"
                  aria-selected={active}
                >
                  <div className="font-semibold tracking-wide text-white">{c.label}</div>
                </button>
              );
            })}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="page space-y-4">
      <Helmet>
        <title>Community News &amp; Updates | Hey Let&apos;s Travel</title>
        <meta
          name="description"
          content="Your hub for posts, announcements, and behind-the-scenes stories covering Events, DJs, and Affiliates across the HLT community."
        />
        <link rel="canonical" href="https://www.hey-lets-travel.com/community" />

        <meta property="og:type" content="website" />
        <meta property="og:title" content="Community News &amp; Updates | Hey Let's Travel" />
        <meta property="og:description" content="Stories and updates from Events, DJs, and Affiliates across the HLT community." />
        <meta property="og:url" content="https://www.hey-lets-travel.com/community" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Community News &amp; Updates | Hey Let's Travel" />
        <meta name="twitter:description" content="Stories and updates from Events, DJs, and Affiliates across the HLT community." />
      </Helmet>

      {/* Intro / CTA */}
      <section className="card p-4 sm:p-6">
        <div className="md:flex md:items-center md:justify-between gap-6">
          <div className="max-w-2xl">
            <h1 className="font-display text-3xl sm:text-4xl text-white">
              Community News &amp; Updates
            </h1>
            <p className="mt-2 text-slate-300">
              Your hub for site posts, announcements, and behind-the-scenes stories
              from upcoming <span className="font-semibold">Events</span> to spotlights on
              <span className="font-semibold"> DJs</span> and partner <span className="font-semibold">Affiliates</span>.
              Use the filters to browse what interests you.
            </p>
          </div>
        </div>
      </section>

      <section className="grid gap-4 lg:grid-cols-2">
        {FEATURED_GUIDES.map((guide) => (
          <FeaturedGuideCard key={guide.to} guide={guide} />
        ))}
      </section>

      {/* Mobile: category dropdown */}
      <section className="sm:hidden">
        <MobileCategoryDropdown
          selected={selected}
          onToggle={(key) => setParams({ category: toggle(selected, key) })}
        />
      </section>

      {/* Desktop: category grid */}
      <section className="hidden sm:grid gap-3 sm:grid-cols-3">
        {CATS.map(c => {
          const active = selected.includes(c.key);
          return (
            <button
              key={c.key}
              onClick={() => setParams({ category: toggle(selected, c.key) })}
              className={`card py-4 text-center transition ${active ? 'border-violet-400/50' : ''} hover:border-white/20`}
            >
              <div className="font-semibold tracking-wide text-white">{c.label}</div>
            </button>
          );
        })}
      </section>

      {/* Filters bar */}
      <div className="sticky top-16 z-10">
        <div className="card bg-black/30 backdrop-blur border-white/10 p-2 flex gap-2 items-center">
          <input
            className="input flex-1"
            placeholder="Search..."
            defaultValue={q}
            onKeyDown={e => e.key === 'Enter' && setParams({ q: e.currentTarget.value })}
          />
          <select
            className="input w-[200px]"
            value={sort}
            onChange={e => setParams({ sort: e.target.value })}
          >
            <option value="newest">Newest</option>
            <option value="oldest">Oldest</option>
            <option value="popular">Most Popular</option>
          </select>
        </div>
      </div>

      {/* Grid */}
      <section id="feed" className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {GUIDE_FEED_CARDS.map((guide) => (
          <ArticleCard key={`feed-${guide.to}`} a={guide} />
        ))}
        {items.map(a => <ArticleCard key={a.id} a={a} />)}
      </section>

      {error && !loading && items.length === 0 && (
        <div className="text-center text-red-400 py-6">{error}</div>
      )}
      {!error && !loading && items.length === 0 && (
        <div className="text-center text-slate-400 py-6">No more articles yet.</div>
      )}
      {loading && <div className="text-center text-slate-400 py-4">Loading...</div>}

      {/* Sentinel */}
      <div ref={sentinelRef} />

      {!hasMore && items.length > 0 && (
        <div className="text-center text-slate-400 py-4">You're all caught up.</div>
      )}

      {/* Back to top */}
      {showTop && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="fixed bottom-6 right-6 btn-primary shadow-lg"
          aria-label="Back to top"
        >
          ↑ Top
        </button>
      )}
    </div>
  );
}

function toggle(arr, v) { return arr.includes(v) ? arr.filter(x => x !== v) : [...arr, v]; }

function FeaturedGuideCard({ guide }) {
  return (
    <article className="group overflow-hidden border border-brand-500/20 bg-[#111111] transition hover:border-brand-500/60 hover:bg-[#151515]">
      <Link to={guide.to} className="block" aria-label={guide.title}>
        {guide.thumbnailUrl && (
          <div className="relative aspect-[16/9] overflow-hidden border-b border-brand-500/20 bg-black">
            <SmartImg
              src={guide.thumbnailUrl}
              alt={guide.thumbnailAlt || guide.title}
              className="h-full w-full object-cover transition duration-500 group-hover:scale-[1.03]"
              width={960}
              height={540}
            />
            <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#111111] via-transparent to-transparent" />
          </div>
        )}
        <div className="p-5">
          <span className="badge bg-brand-500/15 text-brand-500">{guide.category}</span>
          <h2 className="mt-4 font-display text-4xl leading-none text-white md:text-5xl">
            {guide.title}
          </h2>
          <p className="mt-3 text-sm leading-6 text-slate-300">{guide.excerpt}</p>
          <div className="mt-5 text-xs font-semibold uppercase tracking-[0.2em] text-brand-500 transition group-hover:translate-x-1">
            Read guide -&gt;
          </div>
        </div>
      </Link>
    </article>
  );
}

function ArticleCard({ a }) {
  const href = a.to || `/community/${a.slug}`;
  return (
    <article className="card group hover:border-white/20 transition flex flex-col">
      <Link to={href} className="block flex-1" aria-label={a.title}>
        {a.thumbnailUrl ? (
          <div className="relative overflow-hidden rounded-t-[inherit]">
            <SmartImg
              src={a.thumbnailUrl}
              alt={a.thumbnailAlt || a.title}
              className="w-full aspect-video object-cover bg-white/5 border-b border-white/10 transition-transform duration-300 group-hover:scale-105"
              width={640}
              height={360}
            />
          </div>
        ) : (
          <div className="relative grid aspect-video w-full place-items-center overflow-hidden border-b border-white/10 bg-[#0a0a0a] p-6 text-center">
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(212,175,55,0.2),transparent_45%),linear-gradient(135deg,rgba(255,255,255,0.08),transparent_45%)]" />
            <div className="relative">
              <div className="text-[10px] font-semibold uppercase tracking-[0.32em] text-brand-500">Ibiza guide</div>
              <div className="mt-3 font-display text-3xl leading-none text-white">{a.fallbackLabel || a.title}</div>
            </div>
          </div>
        )}

        <div className="p-3">
          <span className="badge">{a.category}</span>
          <h3 className="mt-2 font-semibold text-white leading-snug break-words [overflow-wrap:anywhere]
                         line-clamp-3 md:line-clamp-4 lg:line-clamp-none">
            {a.title}
          </h3>
          {a.excerpt && (
            <p className="mt-1 text-slate-300 text-sm break-words [overflow-wrap:anywhere]
                          line-clamp-3 md:line-clamp-5 lg:line-clamp-none">
              {a.excerpt}
            </p>
          )}
        </div>
      </Link>

      {a.category === 'EVENT' && a.eventId && (
        <div className="px-3 pb-3 mt-auto">
          <Link to={`/purchase/${a.eventId}`} className="btn-primary w-full sm:w-auto">
            Purchase tickets →
          </Link>
        </div>
      )}
    </article>
  );
}
